import React from "react";

export default function GlobalLeader({
  backgroundCol,
  data,
  FirstHead,
  ColorHead,
  secondHead,
  headcol

}) {
  return (
    <div className={`${
      backgroundCol ? backgroundCol : "bg-darkBlue "
    } py-16`}>
      <div className="mainDiv text-white py-36">
        <div className="head w-full lg:w-4/12 fle-col mx-auto justify-center text-center pb-10">
          <h2 className="text-[35px] font-extrabold leading-relaxed">
          {FirstHead ? FirstHead : "A"} <span className={`${headcol ? headcol : "text-orange"}`}>{ColorHead ? ColorHead : "Global Leader"}</span> 
          {secondHead ? secondHead : " in Document Translation Services"}
          
          </h2>

        </div>
        <span className="border-b w-full font-light block border-textlight"></span>
        <div className="content w-full lg:w-7/12 text-white mx-auto justify-center">
          <section
            className=""
          >
            <div className="max-w-5xl mx-auto  mlap:px-6 ">
              {data
                ? data.map(
                    (
                     { FirstWhite,
                      link,
                      ColorHead,
                      lastHeadColor,
                      ThirdBlue,
                      Content,
                      bottomContent,
                      title,
                      detail,
                      borderLine}
                    ) => (
                      <div className={`lap:grid lap:grid-cols-2 py-10 ${borderLine ? "border-b border-border" : null}`}>
                        <div className="lap:pr-12">
                          <h3 className="text-[26px] text-gray font-bold font-secondary leading-relaxed mb-4 lg:mb-0 ">
                            {FirstWhite}{" "}
                            <span className="text-orange">
                              {ColorHead}{" "}
                            </span>
                            {title}{" "}
                            <span className={`${lastHeadColor}`}>
                              {ThirdBlue}{" "}
                            </span>
                          </h3>
                        </div>
                      
                        <div className="">
                          <p className="text-darkMist text-base leading-8 font-opensans">
                            {Content}{detail}
                          </p>
                          {bottomContent ? (
                            <p className="text-darkMist text-base mt-6 leading-8 font-opensans">
                              {bottomContent}
                            </p>
                          ) : null}

                          {link ? (
                            <div className="btn text-white max-w-max hover:text-orange pt-8">
                              <a href="/language-translation-service.php" className="text-lg learnmore-cn">SEE OUR SUPPORTED LANGUAGES</a>
                              <div className="border-b bg-white"></div>{" "}
                              {link}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )
                  )
                : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
